import mainStyle from "../mainStyle.module.scss";
import React, { useState, useEffect, memo, useCallback } from 'react';
import { Typography, Box } from "@mui/material";
import { useDropzone } from 'react-dropzone';
import { useTheme } from "@mui/material/styles";
import icn_btn_bin from "assets/images/icons/icn_btn_bin.svg";

import { ReactComponent as FolderIcon } from "assets/images/icons/icn_table_cell_Folder.svg";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";

const MAX_FILE_SIZE = 2 * 1024 * 1024;

const ModalforPhoto = (props) => {
  const {
    title, content, 
    cancelBtn, saveBtn,
    setOpenModal, setUserPhoto
  } = props;
  const theme = useTheme();

  const handleClose = () => {
    setOpenModal(false);
  };
  const handleUpload = () => {
    if(tmpImage){
      setUserPhoto(tmpImage)
    }
    setOpenModal(false);
  };
  const handleDelete = () =>{
    setTmpImage(null)
    setTmpImageName(null)
    setTmpImageSize(null)
  }

  const [tmpImage, setTmpImage] = useState(null);
  const [tmpImageName, setTmpImageName] = useState(null);
  const [tmpImageSize, setTmpImageSize] = useState(null);
  
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file.size > MAX_FILE_SIZE) {
      // setError('檔案大小超過限制，請選擇小於 5MB 的圖片');
      // setImage(null);  // 清除圖片預覽
      // setImageName('');
      return;  // 如果檔案超過大小限制，則不繼續執行後續操作
    }

    let checkSize = '';
    if(file.size.toString().length <=6){
      checkSize = Math.round(file.size/1024) + ' KB';
    }else{
      checkSize = Math.round(file.size/1024/1024*100)/100 + ' MB';
    }
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file); // 讀取圖片
    }
    reader.onloadend = () => {
      setTmpImage(reader.result);  // 將圖片讀入並顯示
      setTmpImageName(file.name);
      setTmpImageSize(checkSize);
    };
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,  // 處理拖曳事件
    accept: 'image/*',  // 只接受圖片檔案
    // noClick: true,  // 禁止點擊區域觸發文件選擇
    // noKeyboard: true, // 禁止鍵盤操作
  });

  return (
    <>
      <div {...getRootProps()} className={mainStyle['modal_uploadArea']}>
        <div className={mainStyle['modal_Block']} style={{marginBottom:'30px'}}>
          {title &&
            <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[6],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {title}
            </Typography>
          }
        </div>
        <div className={mainStyle['modal_Block']}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Drag your image here.
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']} style={{margin:'10px 0'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Files Supported: JPG, JPEG, PNG, GIF, BMP, SVG.
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            or
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']} style={{margin:'10px 0'}}>
          <Box style={{margin: '10px'}}>
            <OutlineRectangleButton 
              startIcon={<FolderIcon />}
              // width="100px"
              height="32px"
            >
              Browse
              {/* <input {...getInputProps()} 
                type="file" accept=".png, .jpg, .jpeg, .bmp, .svg, .gif"
              /> */}
            </OutlineRectangleButton>
            <input {...getInputProps()} 
              type="file" accept=".png, .jpg, .jpeg, .bmp, .svg, .gif"
            />
          </Box>
        </div>
        <div className={mainStyle['modal_Block']} style={{gap:'10px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Maxinum size:
          </Typography>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            2MB
          </Typography>
        </div>
      </div>
      {tmpImage && (
        <div className={mainStyle['modal_previewArea']}>
          <div style={{display: 'flex', gap: '20px'}}>
            <img src={tmpImage} alt="profile_modal_photo_preview" style={{ width: '60px', height: '60px', objectFit: 'cover' }} />
            <div style={{display: 'grid', alignItems:'center'}}>
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[3],
                  fontWeight: theme.typography.customFontWeight[1],
                  fontFamily: theme.typography.fontFamily,
                }}
                >
                {tmpImageName}
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[3],
                  fontFamily: theme.typography.fontFamily,
                }}
                >
                {tmpImageSize}
              </Typography>
            </div>
          </div>
          <img alt="profile_modal_photo_bin" src={icn_btn_bin} onClick={handleDelete} style={{cursor:'pointer', width: '16px'}}/>
        </div>
      )}
      <div className={mainStyle['modal_Block']}>
        <Box style={{margin: '10px'}}>
          <OutlineButton width="135px" height="42px" onClick={handleClose}>
          {cancelBtn}
          </OutlineButton>
        </Box>
        <Box style={{margin: '10px'}}>
          <SolidButton width="135px" height="42px" onClick={handleUpload}>
            {saveBtn}
          </SolidButton>
        </Box>
      </div>
    </>
  );
}

export default memo(ModalforPhoto);